export default __webpack_public_path__ + "static/media/recent-activity-artwork-2.6beee293.png";